// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3464":"723c62e4bf44b13c","7795":"0fa66ae3341c1e1c"}[chunkId] + ".css";
};